<svelte:head>

  <!-- Global site tag (gtag.js) - Google Analytics -->
  <script async src="https://www.googletagmanager.com/gtag/js?id=UA-126810286-9"></script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-126810286-9');
  </script>

</svelte:head>

<Router>

  {#if !$store.user}

    <Route path="/recover-account">
      <Auth option="recover" />
    </Route>

    <Route path="/reset-password">
      <Auth option="reset" />
    </Route>

    <Route>
      <Auth />
    </Route>

  {:else}

    <Route path="for-you">
      <Cards type="personal" />
    </Route>

    <Route path="for-your-career">
      <Cards type="career" />
    </Route>

    <Route path="mentors">
      <Cards type="mentors" />
    </Route>

    <Route path="forgotten-password">
      <ForgottenPassword />
    </Route>

    <Route path="onboarding">
      <Onboarding />
    </Route>

    <Route path="/contact">
      <Contact />
    </Route>

    <Route>
      <Error />
    </Route>

  {/if}

  <Route path="/terms">
    <Terms />
  </Route>

  <Route path="/privacy">
    <Terms activeContent="privacy" />
  </Route>

  <Route path="/cookies">
    <Terms activeContent="cookies" />
  </Route>

  <Route path="/">
    <Home />
  </Route>

  {#if $store.show_mobile_menu}
    <MobileMenu />
  {/if}

</Router>

{#if $store.card_index > -1}
  <ModalOrganism />
{/if}

{#if $store.show_video }
  <VideoModalOrganism />
{/if}

<script>
  import { onMount } from 'svelte'
  import { Router, Route, navigate } from 'svelte-routing'

  import store from '~/Library/store'

  import Home from '~/Routes/Home'
  import Cards from '~/Routes/Cards'
  import ForgottenPassword from '~/Routes/ForgottenPassword'
  import Auth from '~/Routes/Auth'
  import Onboarding from '~/Routes/Onboarding'
  import Error from '~/Routes/404'
  import Contact from '~/Routes/Contact'
  import Terms from '~/Routes/Terms'

  import MobileMenu from '~/Components/Molecules/MobileMenu'
  import ModalOrganism from '~/Components/Organisms/Modal'
  import VideoModalOrganism from '~/Components/Organisms/VideoModal'
</script>